/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type IntegrationVersion = {
  createdAt: Date;
  version: string;
};

/** @internal */
export const IntegrationVersion$inboundSchema: z.ZodMiniType<
  IntegrationVersion,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    version: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
    });
  }),
);

export function integrationVersionFromJSON(
  jsonString: string,
): SafeParseResult<IntegrationVersion, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IntegrationVersion$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IntegrationVersion' from JSON`,
  );
}
